// TODO - copied from browsing/homepage - can we create common modules like lodash internally to lounge
import { DEPRECATION_WARNING_CLOSED_COOKIE_NAME } from '../constants';
export function serializeCookie(name, value, expires, path, domain, secure) {
    expires = expires ? `;expires=${expires}` : '';
    path = path ? `;path=${path}` : '';
    domain = domain ? `;domain=${domain}` : '';
    const secureString = secure ? `;secure=${secure}` : '';
    return `${name}=${encodeURIComponent(value)}${expires}${path}${domain}${secureString}`;
}
export function setCookie(name, value, delay = null, path = null, domain = null, secure = false) {
    const expires = delay ? new Date(Date.now() + delay).toUTCString() : null;
    document.cookie = serializeCookie(name, value, expires, path, domain, secure);
}
export function getCookie(name, cookiesValue = '') {
    const cookies = cookiesValue || typeof document === 'undefined' ? cookiesValue : document.cookie;
    const pairs = cookies.split(';');
    const found = pairs
        .map(pair => pair.replace(/^[ ]+/, '').replace(/[ ]$/, ''))
        .map(pair => pair.split('='))
        .find(pair => pair[0] === name);
    return found ? decodeURIComponent(found[1]) : undefined;
}
export const hasCookie = (name, cookiesValue = '') => !!getCookie(name, cookiesValue);
export const deleteCookie = (cookieName) => {
    document.cookie = `${cookieName}=;expires=${new Date(0).toUTCString()}`;
};
export const deleteDeprecationModalCookie = () => {
    deleteCookie(DEPRECATION_WARNING_CLOSED_COOKIE_NAME);
};
//# sourceMappingURL=cookie.js.map